module.exports = __webpack_public_path__ + "static/media/img-0.dbd69624.jpeg";